<template>
<div>
  <div class="breadcrumb-list">
    <ol class="breadcrumb">
      <li class="breadcrumb-item active"><a href="#">Request</a></li>
    </ol>
  </div>
  <div class="shift-exchange-wrap">
    <div class="mb-25" v-for="(requests,key) of getRequestData" :key="key">
<!--      <pre ><code>{{ requests }}</code></pre>-->
    <div class="border-bottom mb-15 pb-10">
      <h2 class="mb-0">{{ key }} </h2>
    </div>
<!--    <div class="shift-item" v-for="(request,index) of getRequestData"  v-if="request.type==='Shift Trade' && request.status==='Pending' && request.requestLatestLog !==''" :key="index" :class="[request.status !== 'Pending' ? 'waiting-for-dismiss' : '']">-->
    <div class="shift-item" v-for="(request,index) of requests" :key="index" :class="[request.status !== 'Pending' ? 'waiting-for-dismiss' : '']">
      <div class="shift-info">
        <div class="shift-info-col shift-type">

          <div class="align">
            <router-link v-if="request.status === 'Pending'" :to="{ path: '/employee/profile/' + request.userOnLeave.id + '' }">
              <strong class="shift-name text-capitalize">{{ request.userOnLeave.name }}</strong>
            </router-link>
            <strong class="shift-name text-capitalize" v-else>{{ request.userOnLeave.name }}</strong>
            <div class="d-flex flex-wrap">
              <strong class="shift-desg" v-for="role of request.employeeRole" :key="role.id">
                <i class="ico ico-fill-circle" v-bind:style="{ color : role.get_job_roles !== null ? role.get_job_roles.color : ''}"></i>
                {{ role.get_job_roles !== null ? role.get_job_roles.name : '' }}
              </strong>
            </div>
          </div>
        </div>
        <div class="shift-info-col shift-date" v-if="request.schedule !== null">
          <div class="align">
            <strong class="shift-title">
              {{ request.schedule.date | moment('DD-MM-Y') }}
<!--              {{ weekDays[new Date(request.schedule.date).getDay()] }},
              {{ months[new Date(request.schedule.date).getMonth()] }} {{ new Date(request.schedule.date).getDate() }}-->
              </strong>
            <span class="sub-text">
              {{ request.schedule.start_time.split(':')[0] +':'+ request.schedule.start_time.split(':')[1] }} -
              {{ request.schedule.end_time.split(':')[0] +':'+ request.schedule.end_time.split(':')[1] }}
            </span>
          </div>
        </div>
        <div class="shift-info-col shift-date" v-else>
          <div class="align">
            <strong class="shift-title">
              {{ request.start_datetime | moment('DD-MM-Y') }} To {{ request.end_datetime | moment('DD-MM-Y') }}

<!--              {{ request.start_datetime | moment('D-M-Y') }}-->
<!--              {{ weekDays[new Date(request.start_datetime).getDay()] }} to {{ weekDays[new Date(request.end_datetime).getDay()] }},
              {{ months[new Date(request.start_datetime).getMonth()] }} {{ new Date(request.start_datetime).getDate() }}-->
            </strong>
            <!-- <span class="sub-text">13:15 - 19:15</span> -->
          </div>
        </div>
        <div class="shift-info-col shift-date" v-if="request.schedule !== null">
          <div class="align">
            <strong class="shift-title">
              {{ weekDays[new Date(request.schedule.date).getDay()] }},
              {{ months[new Date(request.schedule.date).getMonth()] }} {{ new Date(request.schedule.date).getDate() }}
            </strong>
            <span class="sub-text">
              <!-- {{ request.schedule.start_time.split(':')[0] +':'+ request.schedule.start_time.split(':')[1] }} - -->
              {{ request.extend_start_datetime === null ? '00:00' : new Date(request.extend_start_datetime).getHours()+':'+ new Date(request.extend_start_datetime).getMinutes() }}
              {{ request.extend_end_datetime === null ? '00:00' : new Date(request.extend_end_datetime).getHours()+':'+ new Date(request.extend_end_datetime).getMinutes() }}
            </span>
          </div>
        </div>
        <div class="shift-info-col shift-date" v-else>
          <div class="align">
            <strong class="shift-title">{{ request.type }}</strong>
            <!-- <span class="sub-text">14:15 - 22:15</span> -->
          </div>
        </div>

        <div class="shift-info-col shift-owner" v-if="request.schedule !== null">
          <div class="align">
            <strong class="sub-title">
              {{ request.body }}
            </strong>
            <!-- <p><em>Initiated by you on behalf of rizwan</em></p> -->
          </div>
        </div>
        <div class="shift-info-col shift-owner" v-else>
          <div class="align">
            <strong class="sub-title">
              {{ request.body }}
            </strong>
            <!-- <p><em>Initiated by you on behalf of rizwan</em></p> -->
          </div>
        </div>
      </div>
      <div class="shift-status" v-if="request.status === 'Pending'">
        <div class="status-msg">
          <p>This request for <span class="text-lowercase">{{request.type}}</span></p>
        </div>
        <div class="btn-con">
          <a href="javascript:void(0)" class="btn accept-btn" :data-id="request.id" @click="acceptOrRejectLeave(request.id,'Accept')">Accept</a>
          <a href="javascript:void(0)" class="btn decline-btn" @click="acceptOrRejectLeave(request.id,'Reject')">Reject</a>
        </div>
      </div>
      <div class="shift-status" v-else>
        <div class="status-msg swap-success">
          <p>This request was for <span class="text-lowercase">{{request.type}}</span> and <span class="text-lowercase">{{request.status}}</span>ed</p>
        </div>
        <div class="btn-con">
          <a href="javascript:void(0)" class="btn dismiss-btn" @click="hideLeaveRow(request.id)">Hide</a>
        </div>
      </div>
    </div>
    </div>
  </div>
</div>
</template>
<script>
import Vue from 'vue'
import moment from 'moment'
import router from '../../router/router'
export default {
  data() {
    return {
      pendingLeaveCount:0,
      pendingLeaveEmployee:[],
      getRequestData:[],
      weekDays:[],
      months:[],
      dismissClass:'waiting-for-dismiss'
    }
  },
  serverPrefetch() {
  },
  created() {
    this.weekDays = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
    this.months = ["January","February","March","April","May","June","July","August","September","October","November","December"];
  },
  mounted() {
    this.getAllLeaves();
  },
  methods: {
    hideLeaveRow(id){
      if(confirm('Are you sure you want to hide this request?')){
        this.$axios({
          method: "post",
            params: {
              request_id: id,
              status:'Hide'
            },
            // url: this.$AcceptOrRejectLeave,
            url: this.$setRequestStatus,
            headers: this.getAuthHeader()
          }).then(res => {
            if (res.data.status == 200) {
              $root.$toast.success(res.data.message);
              this.getAllLeaves();
            }
          });
      }
    },
    acceptOrRejectLeave(id,type){
      if(confirm('Are you sure you want to '+type+' this request?')){
        this.$axios({
          method: "post",
            params: {
              request_id: id,
              status:type
            },
            url: this.$setRequestStatus,
            headers: this.getAuthHeader()
          }).then(res => {
            if (res.data.status == 200) {
              $root.$toast.success(res.data.message);
              this.getAllLeaves();
            }
          });
      }
    },
    getAllLeaves(){
          this.$axios({
            method: "get",
            params: {
              company_id: this.$store.getters.getSelectedCompany.id,
            },
            url: this.$GetAllRequestData,
            headers: this.getAuthHeader()
          }).then(res => {
            if (res.data.status == 200) {
              this.pendingLeaveCount = 0;
              this.pendingLeaveEmployee = [];
              // this.getRequestData = Object.values(res.data.result).reverse();
              this.getRequestData = res.data.result;
              //console.log(this.getRequestData,'this.getRequestData');
            }
          });
        },
  }
}
</script>
